import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const PUSH_REPORTS_RECIPIENT_TABLE_STATE_STORAGE_KEY =
    "userPushReportsRecipientList";

export const PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS = {
    CUSTOM_REPORT_NAME: "customReportName",
    PUSH_REPORT_NAME: "pushReportName",
    TYPE: "type",
    FREQUENCY: "frequency",
    RESPONSIBLE: "responsible",
} as const;

/** The columns filtered by the faceted set of the names they display. */
export type PushReportsRecipientNameColumnId =
    (typeof PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS)[
        | "CUSTOM_REPORT_NAME"
        | "PUSH_REPORT_NAME"
        | "RESPONSIBLE"];

export const pushReportsRecipientListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.CUSTOM_REPORT_NAME,
                desc: false,
            },
        ],
    };

export const pushReportsRecipientListColumnFiltersCodecMap = {
    [PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.CUSTOM_REPORT_NAME]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.PUSH_REPORT_NAME]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.TYPE]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.FREQUENCY]:
        withModeCodec(encodedArrayCodec),
    [PUSH_REPORTS_RECIPIENT_LIST_COLUMN_IDS.RESPONSIBLE]:
        withModeCodec(encodedArrayCodec),
};
